var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.866 10.587c.178-.35.179-.761.001-1.112-.156-.308-.431-.47-.573-.549-.154-.084-.35-.17-.547-.257L3.317 2.328a8 8 0 0 0-.57-.234c-.155-.052-.467-.148-.813-.055-.39.105-.708.383-.856.75-.131.325-.065.637-.028.792.041.17.11.373.18.576l1.396 4.09c.112.329.168.494.273.615a.86.86 0 0 0 .345.243c.152.058.33.058.687.058h6.229c.474 0 .86.374.86.836a.85.85 0 0 1-.86.836H3.948c-.357 0-.535 0-.686.058a.86.86 0 0 0-.345.241c-.104.121-.16.286-.274.614l-1.41 4.093c-.069.203-.139.406-.18.575-.038.155-.105.467.025.792.148.367.464.646.854.752.346.094.658 0 .813-.053.17-.056.37-.144.57-.232l14.428-6.286c.196-.085.393-.17.547-.255.143-.077.418-.239.576-.547"
  })));
};
export default SvgSend;